/* eslint-disable react-refresh/only-export-components */
import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import SuspenseWrapper from "../SuspenseWrapper";

const CategoriesPage = lazy(
  () => import("../../pages/products/CategoriesPage"),
);
const ProductsPage = lazy(() => import("../../pages/products/ProductsPage"));
const ProductEditorPage = lazy(
  () => import("../../pages/products/ProductEditorPage"),
);
const PriceRulesPage = lazy(
  () => import("../../pages/products/PriceRulesPage"),
);
const TagsPage = lazy(() => import("../../pages/products/TagsPage"));
const VariantAttributesPage = lazy(
  () => import("../../pages/products/VariantAttributesPage"),
);
const TestimonialsModerationPage = lazy(
  () => import("../../pages/website/TestimonialsModerationPage"),
);

export const productsRoutes: RouteObject[] = [
  {
    path: "products/categories",
    element: (
      <SuspenseWrapper>
        <CategoriesPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: "products/list",
    element: (
      <SuspenseWrapper>
        <ProductsPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: "products/list/new",
    element: (
      <SuspenseWrapper>
        <ProductEditorPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: "products/list/:id/edit",
    element: (
      <SuspenseWrapper>
        <ProductEditorPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: "products/price-rules",
    element: (
      <SuspenseWrapper>
        <PriceRulesPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: "products/tags",
    element: (
      <SuspenseWrapper>
        <TagsPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: "products/variant-attributes",
    element: (
      <SuspenseWrapper>
        <VariantAttributesPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: "website/testimonials",
    element: (
      <SuspenseWrapper>
        <TestimonialsModerationPage />
      </SuspenseWrapper>
    ),
  },
];
